import { TeContainer, TeContainerSlim, TeDivider, TeText } from '@topcon/tuicl-react';
import styled from 'styled-components';
import { useTranslation } from '@topcon/topcon-utils';
import { use } from 'react';

import { AddressInfo, ServiceAgreementBody } from '../../api/generated/pm';
import { BusinessPartnerCard } from '../BusinessPartnerCard';
import { ServiceAgreementStepActions } from './ServiceAgreementStepActions';
import { ReviewResultContextType } from '../../providers/ReviewResultContext/review-result.types';
import { ReviewResultContext } from '../../providers/ReviewResultContext/review-result.context';

interface ServiceAgreementStepProps {
  serviceAgreement?: ServiceAgreementBody;
  visible: boolean;
  onNextStep: () => void;
}

function ReviewServiceAgreementStep({
  visible,
  serviceAgreement,
  onNextStep,
}: ServiceAgreementStepProps) {
  const { t } = useTranslation();
  const { setResult } = use<ReviewResultContextType>(ReviewResultContext);

  if (!visible || !serviceAgreement) return;

  const showDetails = false;

  const handleReject = () => {
    setResult('declined');
  };

  return (
    <>
      <TeContainer justifyContent="space-between" fill padding={0} gap={0} column>
        <TeContainerSlim column fill padding={['m']} gap="xs2">
          <TeText weight={700} size={20}>
            {t('companyReview')}
          </TeText>
          <TeText color="text.secondary" size={14}>
            {t('serviceAgreement.request.description')}
          </TeText>
        </TeContainerSlim>
        <TeDivider dividerColor="border.secondary" />
        <TeContainerSlim fill grow padding="m" gap="xs" alignItems="center">
          <TeContainerSlimWrapper column fill grow gap="xs">
            <BusinessPartnerCard
              badgeLabel={t('dealer')}
              name={serviceAgreement?.provider?.name ?? ''}
              subName={t('businessCompany')}
              address={serviceAgreement?.provider?.companyAddress as AddressInfo}
            />
          </TeContainerSlimWrapper>
          <TeContainerSlimWrapper column fill grow gap="xs" $span={!showDetails}>
            <BusinessPartnerCard
              badgeLabel={t('customer')}
              name={serviceAgreement?.customer?.name ?? ''}
              subName={t('businessCompany')}
              address={serviceAgreement?.customer?.companyAddress as AddressInfo}
            />

            {/* {showDetails && (
              <ServiceAgreementOrgCard>
                <TeContainerSlim column gap="xs" fill grow>
                  <TeText size={14} weight={700}>
                    {t('serviceAgreement.wrongDetails')}
                  </TeText>
                  <TeText size={12} weight={400}>
                    {t('serviceAgreement.wrongDetailsDescription')}
                  </TeText>
                  <TeButtonOutline
                    text={t('generalInformation.editDetails', { ns: 'settings' })}
                    size="s"
                    teclick={() => setOpenEditCompanyModal(true)}
                  />
                </TeContainerSlim>
              </ServiceAgreementOrgCard>
            )} */}
          </TeContainerSlimWrapper>
        </TeContainerSlim>
        <TeDivider dividerColor="border.secondary" />
        <ServiceAgreementStepActions
          step="companyReview"
          id={serviceAgreement.id}
          onNextStep={onNextStep}
          onReject={handleReject}
        />
      </TeContainer>
      {/* <CompanyDivisionModal
        open={openEditCompanyModal}
        onClose={() => setOpenEditCompanyModal(false)}
        businessPartner={
          {
            ...serviceAgreement?.customer,
            ...serviceAgreement?.customer?.companyAddress,
          } as BusinessPartnerBody
        }
      /> */}
    </>
  );
}

const TeContainerSlimWrapper = styled(TeContainerSlim)<{ $span?: boolean }>`
  width: 100% !important;
  height: 100% !important;
`;

export { ReviewServiceAgreementStep };
